import { gql } from 'apollo-angular';
import VConsentChecklistTasksComposite from '../../../interfaces/v-consent-checklist-tasks-composite';
import { Paginator, PaginatorInfo } from '../../../types/paginator';
import ConsentChecklistStatus from '../../../interfaces/consent-checklist-status';
import ID from '../../../types/id';
import { ConsentStatus } from '../../../interfaces/consent-status';
import { User } from '../../../interfaces/user';

type FetchConsentChecklistTasksResponse = {
  getConsentChecklistTasks: Paginator<
    any,
    PaginatorInfo
  >;
  getChecklistParties: string[];
  getConsentChecklistStatuses: ConsentChecklistStatus[];
  getConsentStatuses: ConsentStatus[];
  me: User;
};
export type QueryGetConsentChecklistTasksOrderOrderByClause = {
  column:
    | 'IS_URGENT_FLAG'
    | 'TIMING_DATE'
    | 'RECEIVED_DATE'
    | 'STARTED'
    | 'DUE_DATE'
    | 'SORT_INDEX';
  order: 'ASC' | 'DESC';
};
export type ConsentChecklistTaskFilterInput = {
  checklist_status_id?: ID;
  project_id?: ID;
  request_status_id?: ID | null;
  due_date?: string | null;
  timing_date?: string | null;
  request_complete?: boolean;
  task_complete?: boolean;
  responsible_party?: string | null;
  developer_id?: string | null;
  sponsor_id?: string | null;
};
type FetchConsentChecklistTasksVariables = {
  order?: QueryGetConsentChecklistTasksOrderOrderByClause[];
  filter?: ConsentChecklistTaskFilterInput;
  excludeRequestStatuses?: string[] | null;
};
const CHECKLIST_TASK_FRAGMENTS = `
  id
  consent_request_id
  project
  project_id
  developer
  developer_id
  request_type
  received_date
  details
  timing_date
  is_urgent_flag
  urgency_note
  request_status
  request_complete
  consent_status_id
  task
  sort_index
  checklist_status
  task_complete
  consent_checklist_status_id
  due_date
  start_date
  past_due
  started
  days_to_complete
  checklist_notes
  responsible_party
  responsible_party_type
  responsible_party_id
  sponsor
  sponsor_id
  total_approvals
  total_approved
  is_denied
`;
export const FETCH_CONSENT_CHECKLIST_TASKS = gql<
  FetchConsentChecklistTasksResponse,
  FetchConsentChecklistTasksVariables
>`
  query fetchConsentChecklistTasks(
    $filter: ConsentChecklistTaskFilterInput
    $order: [QueryGetConsentChecklistTasksOrderOrderByClause!]!
    $excludeRequestStatuses: [String!]
  ) {
    getConsentChecklistTasks(
      filter: $filter
      order: $order
      excludeRequestStatuses: $excludeRequestStatuses
    ) {
      data {
        ${CHECKLIST_TASK_FRAGMENTS}
      }
      paginatorInfo {
        currentPage
        hasMorePages
        total
      }
    }
    getChecklistParties
    getConsentStatuses {
      id
      status
    }
    getConsentChecklistStatuses {
      id
      checklist_status
    }
    me{
      permissionsForResource(resourceType: CONSENTCHECKLISTTASK){
        _create
        _read
        _edit
        _delete
        authorized_fields
      }
    }
  }
`;

export type FetchConsentChecklistTaskPageResponse = {
  getConsentChecklistTasks: Paginator<
    VConsentChecklistTasksComposite,
    PaginatorInfo
  >;
  getChecklistParties: string[];
};
export type FetchConsentChecklistTaskPageVariables = {
  page: number;
  order: QueryGetConsentChecklistTasksOrderOrderByClause[];
  filter?: ConsentChecklistTaskFilterInput;
  excludeRequestStatuses?: string[] | null;
};
export const FETCH_CONSENT_CHECKLIST_TASK_PAGE = gql<
  FetchConsentChecklistTaskPageResponse,
  FetchConsentChecklistTaskPageVariables
>`
  query fetchConsentChecklistTaskPage(
    $order: [QueryGetConsentChecklistTasksOrderOrderByClause!]
    $filter: ConsentChecklistTaskFilterInput
    $page: Int
    $excludeRequestStatuses: [String!]
  ) {
    getConsentChecklistTasks(
      order: $order
      filter: $filter
      page: $page
      excludeRequestStatuses: $excludeRequestStatuses
    ) {
      data {
        ${CHECKLIST_TASK_FRAGMENTS}
      }
      paginatorInfo {
        currentPage
        hasMorePages
        total
      }
    }
    getChecklistParties
  }
`;
